import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfFormSuccessController extends Controller {
  @tracked pastPeriodIds = '';
  queryParams = ['pastPeriodIds'];
}
